import React from 'react';
import '../App.css';

const HomePage: React.FC = () => {
  return (
    <div className="page-container content-wrapper">

      {/* Hero Section */}
      <section className="bg-light py-5 text-center text-md-start">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h1 className="display-5 fw-bold">Odomknite prehľad o kampaniach a výkonnosti</h1>
              <p className="lead text-muted mt-3">
                Kocúr.ai umožňuje marketérom analyzovať, optimalizovať a zvyšovať výkonnosť kampaní prostredníctvom inteligentnej analýzy.
              </p>
              <a href="https://app.kocur.ai" className="btn btn-primary btn-lg mt-4">Poďme na to!</a>
            </div>
            <div className="col-md-6 text-center">
              <img src="/logo.svg" alt="Marketing Analytics Illustration" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5">
        <div className="container">
          <div className="row text-center g-4">
            <div className="col-md-4">
              <i className="bi bi-bar-chart-line fs-1 text-primary mb-3"></i>
              <h5>Komplexná analýza</h5>
              <p className="text-muted">Dive deep into campaign metrics to understand performance and identify growth opportunities.</p>
            </div>
            <div className="col-md-4">
              <i className="bi bi-lightning-fill fs-1 text-primary mb-3"></i>
              <h5>AI optimalizácia</h5>
              <p className="text-muted">Využívajte umelú inteligenciu na získanie použiteľných odporúčaní na zlepšenie výkonnosti kampaní.</p>
            </div>
            <div className="col-md-4">
              <i className="bi bi-person-check-fill fs-1 text-primary mb-3"></i>
              <h5>Segmentácia publika</h5>
              <p className="text-muted">Segmentujte svoje publikum, aby ste prispôsobili kampane a maximalizovali zapojenie.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
